import { render } from "./EditSubject.vue?vue&type=template&id=11fd07f6&ts=true"
import script from "./EditSubject.ts?vue&type=script&lang=ts"
export * from "./EditSubject.ts?vue&type=script&lang=ts"

import "./EditSubject.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__